import React, {
    useEffect,
    useState,
    useRef,
} from 'react';
import PaymentMethodSelector from '../../shared/PaymentMethodSelector';
import { useDispatch, useSelector } from 'react-redux';
import { Autocomplete, CircularProgress, Divider, FormControlLabel, Radio, RadioGroup, TextField } from '@mui/material';
import { Button, FormHelperText } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import { getData, postData } from '../../services/fetch-service';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup'
import { setLlojiPagesesManualet, setManualetLlojiPagesesLoad, setManualetSelectedInsitucioni, setPaymentResponse } from '../store/dataslice';
import PayseraPayment from '../PayseraPayment';
import dayjs from 'dayjs';
import { FaEuroSign } from 'react-icons/fa';
import ReCAPTCHA from 'react-google-recaptcha';
import { LoadingOverlay, Loader } from '@mantine/core';
import Swal from 'sweetalert2';

const customLoader = (
    <div className="payment-load">
        <Loader color="#006" />
        <span>Në procesim...</span>
    </div>
);

const PaymentFieldsOthers = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const reCaptchaRef = useRef(null);

    const [personType, setPersonType] = useState('Fizik');
    const [selectedInstitucioni, setSelectedInstitucioni] = useState(null);
    const [selectedLlojiPageses, setSelectedLlojiPageses] = useState(null);
    const [pagesaLoading, setPagesaLoading] = useState(false);
    const [loanLoading, setLoanLoading] = useState(false);
    const [updateLoader, setUpdateLoader] = useState(false);
    const [paymentMethodCode, setPaymentMethodCode] = useState("wallet");

    const SelectedPayment = useSelector((state) => state.Website.data.PaymentSelected);
    const LlojiPagesesList = useSelector((state) => state.Website.data.LlojiPagesesManualet);
    const InstitucioniList = useSelector((state) => state.Website.data.Institucionet);
    const llojiPagesesLoad = useSelector((state) => state.Website.data.ManualetLlojiPagesesLoad);

    const [Loan, setLoan] = useState(false);

    useEffect(() => {
        setSelectedLlojiPageses(null);
        if (selectedInstitucioni === null) {
            dispatch(setLlojiPagesesManualet([]));
        }
    }, [selectedInstitucioni]);

    const handleBack = () => {
        navigate('/');
    }

    const handlePaymentMethodCode = (event) => {
        setPaymentMethodCode(event.target.value);
    };

    const clickPaymentMethodCode = (value) => {
        setPaymentMethodCode(value);
    };

    const payment_validationSchema = Yup.object().shape({
        Email: Yup.string().email('Email nuk është valid!').required('Email është obligativ!'),
        llojiPagesesID: Yup.string().required('Fusha është obligative!'),
        institucioniId: Yup.string().required('Fusha është obligative!'),
        numriSerik: Yup.string().required('Fusha është obligative!'),
        emri: Yup.string().required('Emri është obligative!'),
        llojiKlientit: Yup.string(),
        mbiemri: Yup.string().test('isRequiredForFizik', 'Mbiemri është obligativ', function (value) {
            const { llojiKlientit } = this.parent;
            if (llojiKlientit === 'Fizik') {
                return !!value;
            }
            return true;
        }),
        strVlera: Yup.string().required('Fusha është obligative!'),
    });

    const today = new Date();
    const strDataPageses = dayjs(today).format('DD/MM/YYYY');

    const formik = useFormik({
        initialValues: {
            Email: '',
            provizioni: 0,
            strProvizioni: '0',
            llojiPagesesID: '',
            institucioniId: '',
            numriSerik: '',
            strDataPageses: `${strDataPageses}`,
            llojiKlientit: 'Fizik',
            emri: '',
            mbiemri: '',
            pershkrimi: 'Pagesa online',
            strVlera: '',
            strVleraTotale: '0',
            paymentMethod: 3,
            sherbimiTipiID: 7,
            // shpenzimet: 0,
            unirefOK: false,
        },
        validationSchema: payment_validationSchema,
        onSubmit: (values) => {
            reCaptchaRef.current.reset();
            postPagesaPerSherbime(values);
        },
    });

    const postPagesaPerSherbime = async (data) => {
        const token = await reCaptchaRef.current.executeAsync();
        try {
            setUpdateLoader(true);
            const newData = {
                ...data,
                shuma: provizioni && provizioni.strShuma,
                provizioni: provizioni && provizioni.provizioni,
                viti: `${new Date().getFullYear()}`,
                strProvizioni: `${provizioni && provizioni.provizioni}`,
                numriSerik: data.numriSerik,
                numriUnikPageses: data.numriSerik,
                strDataPageses: `${strDataPageses}`,
                strVlera: `${provizioni && provizioni.strtotal_pagesa}`,
                strVleraTotale: `${provizioni && provizioni.strtotal_pagesa}`,
                token: token,
                PayWithLoan: Loan ? true : false,
                PaymentMethodCode: paymentMethodCode,
            }
            if (provizioni) {
                const response = await postData('Pagesat/PagesaPerSherbime', newData);
                if (response && response.status === 200) {
                    setLoanLoading(false);
                    setPagesaLoading(false);
                    setUpdateLoader(false);
                    const paymentWindow = window.open('', '_self');
                    paymentWindow.location.href = `${response.data.link}`;
                }
            }
        } catch (error) {
            setLoanLoading(false);
            setPagesaLoading(false);
            setUpdateLoader(false);
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: `${error.response ? error.response.data.modelState.Error.errors[0].errorMessage : "Pagesa dështoi!"}`
            });
        }
    }

    const handlePayProcess = () => {
        if (paymentMethodCode === "PaySeraKredi") {
            handlePayWithLoan();
        } else {
            handlePay();
        }
    }

    const handlePay = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                setPagesaLoading(true);
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
            }
        });
    }

    const handlePayWithLoan = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                setLoanLoading(true);
                setLoan(true);
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
            }
        });
    }

    const handleInstitucioniSelectChange = (event, newValue) => {
        setSelectedInstitucioni(newValue);
        dispatch(setManualetSelectedInsitucioni(newValue));
        if (newValue !== null) {
            dispatch(setManualetLlojiPagesesLoad(true));
        }
        if (newValue && newValue.id) {
            formik.setFieldValue('institucioniId', newValue.id)
        } else {
            formik.setFieldValue('institucioniId', '')
        }
    };

    const handleLlojiPagesesSelectChange = (event, newValue) => {
        setSelectedLlojiPageses(newValue);
        if (newValue && newValue.id) {
            formik.setFieldValue('llojiPagesesID', newValue.id)
        } else {
            formik.setFieldValue('llojiPagesesID', '')
        }
    };

    const handlePersonTypeChange = (event, newValue) => {
        setPersonType(event.target.value);
        formik.setFieldValue('llojiKlientit', event.target.value)
    };

    // provisioni

    const [provizioni, setProvizioni] = useState(null);
    const [shumaKey, setShumaKey] = useState(0);

    const getProvizioni = async (data) => {
        try {
            const response = await getData(`Pagesat/GetProvision?LlojiPagesesID=${selectedLlojiPageses.id}&Amount=${formik.values.strVlera}`, data);
            if (response && response.data && response.data.success === true) {
                setProvizioni(response.data)
            } else if (response && response.data && response.data.success === false) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Informim',
                    text: `${response.data.responseText}`
                });
                formik.setFieldValue('strVlera', null);
                setProvizioni(null);
                setShumaKey(prev => prev + 1);
            }
        } catch (error) {
            // Swal.fire({
            //     icon: 'error',
            //     title: 'Gabim',
            //     text: 'Ka ndodhur një gabim!'
            // });
            formik.setFieldValue('strVlera', null);
            setProvizioni(null);
            setShumaKey(prev => prev + 1);
            // setInstitucioniList(null);
        }
    }

    useEffect(() => {
        if (formik.values.strVlera !== '') {
            getProvizioni();
        }
    }, [selectedLlojiPageses, formik.values.strVlera]);

    return (
        <div className="paysera-home">
            <div className="home-header home-header-others">
                <h1 className='headline-font'>
                    {SelectedPayment.description}
                </h1>
                <span className='home-description body-font'>Për të realizaur pagesat nëpërmjet Paysera, ju lutemi zgjedhni institucionin përkatës, llojin e pagesës dhe plotësoni të dhënat tjera.</span>
            </div>
            <div className="paysera-form-body other-feilds">
                <div className="form-box">
                    <Divider className='subheading-font' textAlign="center">Të dhënat e faturës</Divider>
                    <div className="paysera-form others-search">
                        <div className="paysera-select">
                            <label
                                className={formik.touched.institucioniId && formik.errors.institucioniId ? 'label-top' : ''}
                                htmlFor="Institucioni"
                            >
                                Institucioni <span className="required">*</span>
                            </label>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={InstitucioniList}
                                value={selectedInstitucioni}
                                onChange={handleInstitucioniSelectChange}
                                sx={{ width: 300 }}
                                size='small'
                                name='institucioniId'
                                loading={InstitucioniList && InstitucioniList.length === 0 ? true : false}
                                loadingText={
                                    <div className="dropdownLoader">
                                        <CircularProgress size={20} color="inherit" />
                                    </div>
                                }
                                noOptionsText={
                                    InstitucioniList && InstitucioniList.length === 0 &&
                                    (
                                        <div className="dropdownLoader">
                                            <CircularProgress size={20} color="inherit" />
                                        </div>
                                    )
                                }
                                renderInput={(params) => (
                                    <div className="input">
                                        <TextField
                                            {...params}
                                            label=""
                                            variant="outlined"
                                            placeholder='Zgjedh institucionin'
                                            fullWidth
                                            error={formik.touched.institucioniId && formik.errors.institucioniId}
                                        />
                                        {
                                            formik.touched.institucioniId && formik.errors.institucioniId && (
                                                <FormHelperText>{formik.errors.institucioniId}</FormHelperText>
                                            )
                                        }
                                    </div>
                                )}
                            />
                        </div>
                        <div className="paysera-select">
                            <label
                                className={formik.touched.llojiPagesesID && formik.errors.llojiPagesesID ? 'label-top' : ''}
                                htmlFor="Lloji Pagesës"
                            >
                                Lloji Pagesës <span className="required">*</span>
                            </label>
                            <Autocomplete
                                key={LlojiPagesesList}
                                disablePortal
                                id="combo-box-demo"
                                options={LlojiPagesesList}
                                value={selectedLlojiPageses}
                                loading={llojiPagesesLoad}
                                loadingText={
                                    <div className="dropdownLoader">
                                        <CircularProgress size={20} color="inherit" />
                                    </div>
                                }
                                onChange={handleLlojiPagesesSelectChange}
                                sx={{ width: 300 }}
                                disabled={LlojiPagesesList && LlojiPagesesList.length === 0}
                                size='small'
                                name='llojiPagesesID'
                                onBlur={formik.handleBlur}
                                // noOptionsText="Mungon Institucioni"
                                noOptionsText={
                                    <div className="dropdownLoader">
                                        <CircularProgress size={20} color="inherit" />
                                    </div>
                                }
                                renderInput={(params) => (
                                    <div className="input">
                                        <TextField
                                            {...params}
                                            label=""
                                            variant="outlined"
                                            placeholder="Zgjedh llojin e pagesës"
                                            fullWidth
                                            error={formik.touched.llojiPagesesID && formik.errors.llojiPagesesID}
                                        />
                                        {
                                            formik.touched.llojiPagesesID && formik.errors.llojiPagesesID && (
                                                <FormHelperText>{formik.errors.llojiPagesesID}</FormHelperText>
                                            )
                                        }
                                    </div>
                                )}
                            />
                        </div>
                        <div className="paysera-inputLabel">
                            <label
                                className={formik.touched.numriSerik && formik.errors.numriSerik ? 'label-top' : ''}
                                htmlFor="Numri Serik"
                            >
                                Numri Serik <span className="required">*</span>
                            </label>
                            <div className="input">
                                <OutlinedInput
                                    size="small"
                                    id="outlined-adornment-input"
                                    placeholder="Numri Serik"
                                    type='text'
                                    aria-describedby="outlined-input-helper-text"
                                    inputProps={{
                                        'aria-label': 'input',
                                        inputMode: 'none',
                                    }}
                                    name='numriSerik'
                                    value={formik.values.numriSerik}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.numriSerik && formik.errors.numriSerik}
                                />
                                {
                                    formik.touched.numriSerik && formik.errors.numriSerik && (
                                        <FormHelperText>{formik.errors.numriSerik}</FormHelperText>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-box">
                    <Divider className='subheading-font' textAlign="center">Shënimet për klientin</Divider>
                    <div className="paysera-form others-inputs">
                        <div className="radio-person">
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="llojiKlientit"
                                value={personType}
                                onChange={handlePersonTypeChange}
                            >
                                <FormControlLabel value="Fizik" control={<Radio />} label="Person Fizik" />
                                <FormControlLabel value="Juridik" control={<Radio />} label="Person Juridik" />
                            </RadioGroup>
                        </div>
                        <div className="paysera-inputLabel">
                            <label
                                className={formik.touched.emri && formik.errors.emri ? 'label-top' : ''}
                                htmlFor={personType === 'Fizik' ? 'Emri' : 'Emri i Kompanisë'}
                            >
                                {personType === 'Fizik' ? 'Emri' : 'Emri i Kompanisë'}
                                <span className="required"> *</span>
                            </label>
                            <div className="input">
                                <OutlinedInput
                                    size="small"
                                    id="outlined-adornment-input"
                                    placeholder={personType === 'Fizik' ? 'Emri' : 'Emri i Kompanisë'}
                                    type='text'
                                    name='emri'
                                    aria-describedby="outlined-input-helper-text"
                                    inputProps={{
                                        'aria-label': 'input',
                                    }}
                                    value={formik.values.emri}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.emri && formik.errors.emri}
                                />
                                {
                                    formik.touched.emri && formik.errors.emri && (
                                        <FormHelperText>{formik.errors.emri}</FormHelperText>
                                    )
                                }
                            </div>
                        </div>
                        {personType === 'Fizik' &&
                            <div className="paysera-inputLabel">
                                <label
                                    htmlFor="mbiemri"
                                    className={formik.touched.mbiemri && formik.errors.mbiemri ? 'label-top' : ''}
                                >
                                    Mbiemri
                                    <span className="required"> *</span>
                                </label>
                                <div className="input">
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Mbiemri"
                                        type='text'
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                        name='mbiemri'
                                        value={formik.values.mbiemri}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.mbiemri && formik.errors.mbiemri}
                                    />
                                    {
                                        formik.touched.mbiemri && formik.errors.mbiemri && (
                                            <FormHelperText>{formik.errors.mbiemri}</FormHelperText>
                                        )
                                    }
                                </div>
                            </div>
                        }
                        <div className="paysera-inputLabel">
                            <label className={formik.touched.Email && formik.errors.Email ? 'label-top' : ''} htmlFor="Numri Serik">Email <span className="required">*</span></label>
                            <div className="input">
                                <OutlinedInput
                                    size="small"
                                    id="outlined-adornment-input"
                                    placeholder="Shëno email-in tuaj"
                                    name='Email'
                                    type="email"
                                    aria-describedby="outlined-input-helper-text"
                                    inputProps={{
                                        'aria-label': 'input',
                                    }}
                                    value={formik.values.Email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.Email && formik.errors.Email}
                                />
                                {
                                    formik.touched.Email && formik.errors.Email && (
                                        <FormHelperText>{formik.errors.Email}</FormHelperText>
                                    )
                                }
                            </div>
                        </div>
                        <div className="paysera-inputLabel">
                            <label htmlFor="Numri Serik">Adresa</label>
                            <OutlinedInput
                                size="small"
                                id="outlined-adornment-input"
                                placeholder="Adresa"
                                aria-describedby="outlined-input-helper-text"
                                name='paguesiAdresa'
                                onChange={(event) => formik.setFieldValue('paguesiAdresa', event.target.value)}
                                inputProps={{
                                    'aria-label': 'input',
                                }}
                            />
                        </div>
                        <div className="paysera-inputLabel">
                            <label
                                className={formik.touched.strVlera && formik.errors.strVlera ? 'label-top' : ''}
                                htmlFor="Shuma e pagesës"
                            >
                                Shuma e pagesës <span className="required">*</span>
                            </label>
                            <div className="input">
                                <OutlinedInput
                                    size="small"
                                    id="outlined-adornment-input"
                                    placeholder="Shuma"
                                    className='number-input'
                                    type='number'
                                    aria-describedby="outlined-input-helper-text"
                                    inputProps={{
                                        'aria-label': 'input',
                                        inputMode: 'numeric'
                                    }}
                                    key={shumaKey}
                                    endAdornment={<FaEuroSign />}
                                    name='strVlera'
                                    value={formik.values.strVlera}
                                    onChange={(e) => {
                                        const stringValue = e.target.value.toString();
                                        formik.handleChange({
                                            target: {
                                                name: 'strVlera',
                                                value: stringValue,
                                            },
                                        });
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.strVlera && formik.errors.strVlera}
                                />
                                {
                                    formik.touched.strVlera && formik.errors.strVlera && (
                                        <FormHelperText>{formik.errors.strVlera}</FormHelperText>
                                    )
                                }
                            </div>
                        </div>
                        <div className="paysera-inputLabel">
                            <label htmlFor="Provizioni"> Provizioni</label>
                            <div className="input">
                                <OutlinedInput
                                    size="small"
                                    id="outlined-adornment-input"
                                    placeholder="Provizioni"
                                    key={shumaKey}
                                    readOnly
                                    aria-describedby="outlined-input-helper-text"
                                    inputProps={{
                                        'aria-label': 'input',
                                    }}
                                    name='Provizioni'
                                    value={provizioni && provizioni.provizioni}
                                />
                            </div>
                        </div>
                        <div className="paysera-inputLabel">
                            <label htmlFor="Provizioni">Shuma Totale</label>
                            <div className="input">
                                <OutlinedInput
                                    size="small"
                                    id="outlined-adornment-input"
                                    placeholder="Shuma Totale"
                                    endAdornment={<FaEuroSign />}
                                    readOnly
                                    key={shumaKey}
                                    aria-describedby="outlined-input-helper-text"
                                    inputProps={{
                                        'aria-label': 'input',
                                    }}
                                    name='strVleraTotale'
                                    value={provizioni && provizioni.strtotal_pagesa}
                                />
                            </div>
                        </div>
                        <PaymentMethodSelector
                                    paymentMethodCode={paymentMethodCode}
                                    onPaymentMethodChange={handlePaymentMethodCode}
                                    onPaymentMethodClick={clickPaymentMethodCode}
                                />
                        <div className="p-buttons">
                            <div className="payForm-btn">
                                <Button type="button" variant="outlined" onClick={handleBack}>
                                    Kthehu
                                </Button>
                                {/* <Button
                                    id="payNow"
                                    type="button"
                                    variant="contained"
                                    onClick={handlePayWithLoan}
                                    disabled
                                    startIcon={loanLoading && <CircularProgress size={20} color="inherit" />}
                                >
                                    {loanLoading ? 'Loading...' : 'Paguaj përmes kredisë'}
                                </Button> */}
                                <Button
                                    id="payNow"
                                    type="button"
                                    variant="contained"
                                    onClick={handlePayProcess}
                                    disabled
                                    // disabled={isLoading}
                                    startIcon={pagesaLoading && <CircularProgress size={20} color="inherit" />}
                                >
                                    {pagesaLoading ? 'Loading...' : 'Paguaj'}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ReCAPTCHA
                badge="bottomleft"
                sitekey={process.env.REACT_APP_SITE_KEY}
                size="invisible"
                ref={reCaptchaRef}
            />
            <PayseraPayment />
            <LoadingOverlay loader={customLoader} visible={updateLoader} />
        </div>
    )
}

export default PaymentFieldsOthers
